export enum MarketingEmailStatuses {
  MANDATORY = 'mandatory',
  OPTIONAL = 'optional',
  UNKNOWN = 'unknown',
}
